// @ts-strict-ignore
import styled from 'styled-components';
import { spacing, breakpoint } from '@carvana/ds-styles';

const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing.md};
  margin-top: 0;

  @media screen and (min-width: ${breakpoint.sm}) {
    margin-top: ${spacing.lg};
  }

  @media screen and (max-width: ${breakpoint.sm}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const VinInputWrapper = styled.div`
  flex: 1;

  @media screen and (max-width: ${breakpoint.sm}) {
    width: 100%;
  }
`;

export { Row, VinInputWrapper };
